/* tslint:disable */
/* eslint-disable */
/**
 * rb-c3po-warehouse
 * API für die Verwaltung von Warenausgangsaufträgen, Artikeln, Chargen und Seriennummern
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddItemToOutboundOrderRequest,
  OutboundOrder,
  OutboundOrderItem,
  OutboundOrderPagable,
  RemoveSerialFromOutboundOrderItemRequest,
} from '../models';
import {
    AddItemToOutboundOrderRequestFromJSON,
    AddItemToOutboundOrderRequestToJSON,
    OutboundOrderFromJSON,
    OutboundOrderToJSON,
    OutboundOrderItemFromJSON,
    OutboundOrderItemToJSON,
    OutboundOrderPagableFromJSON,
    OutboundOrderPagableToJSON,
    RemoveSerialFromOutboundOrderItemRequestFromJSON,
    RemoveSerialFromOutboundOrderItemRequestToJSON,
} from '../models';

export interface AddItemToOutboundOrderOperationRequest {
    orderId: string;
    addItemToOutboundOrderRequest: AddItemToOutboundOrderRequest;
}

export interface ConfirmOutboundOrderRequest {
    orderId: string;
}

export interface CreateOutboundOrderRequest {
    outboundOrder: OutboundOrder;
}

export interface DeleteOutboundOrderRequest {
    orderId: string;
}

export interface GetOutboundOrderByIdRequest {
    orderId: string;
}

export interface GetOutboundOrderItemsRequest {
    orderId: string;
}

export interface GetOutboundOrderScanRequest {
    orderId: string;
    scanned: string;
}

export interface GetOutboundOrdersRequest {
    limit?: number;
    page?: number;
    sortBy?: string;
    orderBy?: GetOutboundOrdersOrderByEnum;
}

export interface IncrementArticleAmountRequest {
    orderId: string;
    itemId: string;
    amount: string;
    batch?: string;
}

export interface RemoveSerialFromOutboundOrderItemOperationRequest {
    orderId: string;
    itemId: string;
    removeSerialFromOutboundOrderItemRequest: RemoveSerialFromOutboundOrderItemRequest;
}

export interface SetArticleAmountRequest {
    orderId: string;
    itemId: string;
    amount: string;
    batch?: string;
}

export interface UpdateOutboundOrderRequest {
    orderId: string;
    outboundOrder: OutboundOrder;
}

export interface UpdateOutboundOrderItemRequest {
    orderId: string;
    itemId: string;
    outboundOrderItem: OutboundOrderItem;
}

/**
 * 
 */
export class WarehouseApi extends runtime.BaseAPI {

    /**
     * Fügt einen Artikel zu einem SalesWrap hinzu
     */
    async addItemToOutboundOrderRaw(requestParameters: AddItemToOutboundOrderOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutboundOrder>> {
        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
            throw new runtime.RequiredError('orderId','Required parameter requestParameters.orderId was null or undefined when calling addItemToOutboundOrder.');
        }

        if (requestParameters.addItemToOutboundOrderRequest === null || requestParameters.addItemToOutboundOrderRequest === undefined) {
            throw new runtime.RequiredError('addItemToOutboundOrderRequest','Required parameter requestParameters.addItemToOutboundOrderRequest was null or undefined when calling addItemToOutboundOrder.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/outbound-orders/{orderId}/add`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters.orderId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddItemToOutboundOrderRequestToJSON(requestParameters.addItemToOutboundOrderRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutboundOrderFromJSON(jsonValue));
    }

    /**
     * Fügt einen Artikel zu einem SalesWrap hinzu
     */
    async addItemToOutboundOrder(requestParameters: AddItemToOutboundOrderOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutboundOrder> {
        const response = await this.addItemToOutboundOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Liefert ein Order
     */
    async confirmOutboundOrderRaw(requestParameters: ConfirmOutboundOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutboundOrder>> {
        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
            throw new runtime.RequiredError('orderId','Required parameter requestParameters.orderId was null or undefined when calling confirmOutboundOrder.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/outbound-orders/{orderId}/confirm`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters.orderId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutboundOrderFromJSON(jsonValue));
    }

    /**
     * Liefert ein Order
     */
    async confirmOutboundOrder(requestParameters: ConfirmOutboundOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutboundOrder> {
        const response = await this.confirmOutboundOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Erstellt einen neuen Warenausgangsauftrag
     * Neuen Warenausgangsauftrag erstellen
     */
    async createOutboundOrderRaw(requestParameters: CreateOutboundOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutboundOrder>> {
        if (requestParameters.outboundOrder === null || requestParameters.outboundOrder === undefined) {
            throw new runtime.RequiredError('outboundOrder','Required parameter requestParameters.outboundOrder was null or undefined when calling createOutboundOrder.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/outbound-orders`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OutboundOrderToJSON(requestParameters.outboundOrder),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutboundOrderFromJSON(jsonValue));
    }

    /**
     * Erstellt einen neuen Warenausgangsauftrag
     * Neuen Warenausgangsauftrag erstellen
     */
    async createOutboundOrder(requestParameters: CreateOutboundOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutboundOrder> {
        const response = await this.createOutboundOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Löscht einen Warenausgangsauftrag
     * Warenausgangsauftrag löschen
     */
    async deleteOutboundOrderRaw(requestParameters: DeleteOutboundOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
            throw new runtime.RequiredError('orderId','Required parameter requestParameters.orderId was null or undefined when calling deleteOutboundOrder.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/outbound-orders/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters.orderId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Löscht einen Warenausgangsauftrag
     * Warenausgangsauftrag löschen
     */
    async deleteOutboundOrder(requestParameters: DeleteOutboundOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteOutboundOrderRaw(requestParameters, initOverrides);
    }

    /**
     * Ruft Details eines spezifischen Warenausgangsauftrags ab
     * Einzelnen Warenausgangsauftrag abrufen
     */
    async getOutboundOrderByIdRaw(requestParameters: GetOutboundOrderByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutboundOrder>> {
        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
            throw new runtime.RequiredError('orderId','Required parameter requestParameters.orderId was null or undefined when calling getOutboundOrderById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/outbound-orders/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters.orderId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutboundOrderFromJSON(jsonValue));
    }

    /**
     * Ruft Details eines spezifischen Warenausgangsauftrags ab
     * Einzelnen Warenausgangsauftrag abrufen
     */
    async getOutboundOrderById(requestParameters: GetOutboundOrderByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutboundOrder> {
        const response = await this.getOutboundOrderByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Ruft alle Artikel eines spezifischen Warenausgangsauftrags ab
     * Alle Artikel eines Warenausgangsauftrags abrufen
     */
    async getOutboundOrderItemsRaw(requestParameters: GetOutboundOrderItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OutboundOrderItem>>> {
        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
            throw new runtime.RequiredError('orderId','Required parameter requestParameters.orderId was null or undefined when calling getOutboundOrderItems.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/outbound-orders/{orderId}/items`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters.orderId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutboundOrderItemFromJSON));
    }

    /**
     * Ruft alle Artikel eines spezifischen Warenausgangsauftrags ab
     * Alle Artikel eines Warenausgangsauftrags abrufen
     */
    async getOutboundOrderItems(requestParameters: GetOutboundOrderItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OutboundOrderItem>> {
        const response = await this.getOutboundOrderItemsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Liefert ein Order
     */
    async getOutboundOrderScanRaw(requestParameters: GetOutboundOrderScanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutboundOrder>> {
        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
            throw new runtime.RequiredError('orderId','Required parameter requestParameters.orderId was null or undefined when calling getOutboundOrderScan.');
        }

        if (requestParameters.scanned === null || requestParameters.scanned === undefined) {
            throw new runtime.RequiredError('scanned','Required parameter requestParameters.scanned was null or undefined when calling getOutboundOrderScan.');
        }

        const queryParameters: any = {};

        if (requestParameters.scanned !== undefined) {
            queryParameters['scanned'] = requestParameters.scanned;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/outbound-orders/{orderId}/scanArticle`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters.orderId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutboundOrderFromJSON(jsonValue));
    }

    /**
     * Liefert ein Order
     */
    async getOutboundOrderScan(requestParameters: GetOutboundOrderScanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutboundOrder> {
        const response = await this.getOutboundOrderScanRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Ruft eine Liste aller Warenausgangsaufträge ab
     * Alle Warenausgangsaufträge abrufen
     */
    async getOutboundOrdersRaw(requestParameters: GetOutboundOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutboundOrderPagable>> {
        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        if (requestParameters.orderBy !== undefined) {
            queryParameters['orderBy'] = requestParameters.orderBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/outbound-orders`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutboundOrderPagableFromJSON(jsonValue));
    }

    /**
     * Ruft eine Liste aller Warenausgangsaufträge ab
     * Alle Warenausgangsaufträge abrufen
     */
    async getOutboundOrders(requestParameters: GetOutboundOrdersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutboundOrderPagable> {
        const response = await this.getOutboundOrdersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Liefert ein Order
     */
    async incrementArticleAmountRaw(requestParameters: IncrementArticleAmountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutboundOrder>> {
        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
            throw new runtime.RequiredError('orderId','Required parameter requestParameters.orderId was null or undefined when calling incrementArticleAmount.');
        }

        if (requestParameters.itemId === null || requestParameters.itemId === undefined) {
            throw new runtime.RequiredError('itemId','Required parameter requestParameters.itemId was null or undefined when calling incrementArticleAmount.');
        }

        if (requestParameters.amount === null || requestParameters.amount === undefined) {
            throw new runtime.RequiredError('amount','Required parameter requestParameters.amount was null or undefined when calling incrementArticleAmount.');
        }

        const queryParameters: any = {};

        if (requestParameters.amount !== undefined) {
            queryParameters['amount'] = requestParameters.amount;
        }

        if (requestParameters.batch !== undefined) {
            queryParameters['batch'] = requestParameters.batch;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/outbound-orders/{orderId}/items/{itemId}/incrementAmount`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters.orderId))).replace(`{${"itemId"}}`, encodeURIComponent(String(requestParameters.itemId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutboundOrderFromJSON(jsonValue));
    }

    /**
     * Liefert ein Order
     */
    async incrementArticleAmount(requestParameters: IncrementArticleAmountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutboundOrder> {
        const response = await this.incrementArticleAmountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Entfernt eine Seriennummer
     */
    async removeSerialFromOutboundOrderItemRaw(requestParameters: RemoveSerialFromOutboundOrderItemOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutboundOrder>> {
        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
            throw new runtime.RequiredError('orderId','Required parameter requestParameters.orderId was null or undefined when calling removeSerialFromOutboundOrderItem.');
        }

        if (requestParameters.itemId === null || requestParameters.itemId === undefined) {
            throw new runtime.RequiredError('itemId','Required parameter requestParameters.itemId was null or undefined when calling removeSerialFromOutboundOrderItem.');
        }

        if (requestParameters.removeSerialFromOutboundOrderItemRequest === null || requestParameters.removeSerialFromOutboundOrderItemRequest === undefined) {
            throw new runtime.RequiredError('removeSerialFromOutboundOrderItemRequest','Required parameter requestParameters.removeSerialFromOutboundOrderItemRequest was null or undefined when calling removeSerialFromOutboundOrderItem.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/outbound-orders/{orderId}/items/{itemId}/removeSerial`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters.orderId))).replace(`{${"itemId"}}`, encodeURIComponent(String(requestParameters.itemId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RemoveSerialFromOutboundOrderItemRequestToJSON(requestParameters.removeSerialFromOutboundOrderItemRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutboundOrderFromJSON(jsonValue));
    }

    /**
     * Entfernt eine Seriennummer
     */
    async removeSerialFromOutboundOrderItem(requestParameters: RemoveSerialFromOutboundOrderItemOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutboundOrder> {
        const response = await this.removeSerialFromOutboundOrderItemRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Liefert ein Order
     */
    async setArticleAmountRaw(requestParameters: SetArticleAmountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutboundOrder>> {
        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
            throw new runtime.RequiredError('orderId','Required parameter requestParameters.orderId was null or undefined when calling setArticleAmount.');
        }

        if (requestParameters.itemId === null || requestParameters.itemId === undefined) {
            throw new runtime.RequiredError('itemId','Required parameter requestParameters.itemId was null or undefined when calling setArticleAmount.');
        }

        if (requestParameters.amount === null || requestParameters.amount === undefined) {
            throw new runtime.RequiredError('amount','Required parameter requestParameters.amount was null or undefined when calling setArticleAmount.');
        }

        const queryParameters: any = {};

        if (requestParameters.amount !== undefined) {
            queryParameters['amount'] = requestParameters.amount;
        }

        if (requestParameters.batch !== undefined) {
            queryParameters['batch'] = requestParameters.batch;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/outbound-orders/{orderId}/items/{itemId}/setAmount`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters.orderId))).replace(`{${"itemId"}}`, encodeURIComponent(String(requestParameters.itemId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutboundOrderFromJSON(jsonValue));
    }

    /**
     * Liefert ein Order
     */
    async setArticleAmount(requestParameters: SetArticleAmountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutboundOrder> {
        const response = await this.setArticleAmountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Aktualisiert einen bestehenden Warenausgangsauftrag
     * Warenausgangsauftrag aktualisieren
     */
    async updateOutboundOrderRaw(requestParameters: UpdateOutboundOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutboundOrder>> {
        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
            throw new runtime.RequiredError('orderId','Required parameter requestParameters.orderId was null or undefined when calling updateOutboundOrder.');
        }

        if (requestParameters.outboundOrder === null || requestParameters.outboundOrder === undefined) {
            throw new runtime.RequiredError('outboundOrder','Required parameter requestParameters.outboundOrder was null or undefined when calling updateOutboundOrder.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/outbound-orders/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters.orderId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OutboundOrderToJSON(requestParameters.outboundOrder),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutboundOrderFromJSON(jsonValue));
    }

    /**
     * Aktualisiert einen bestehenden Warenausgangsauftrag
     * Warenausgangsauftrag aktualisieren
     */
    async updateOutboundOrder(requestParameters: UpdateOutboundOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutboundOrder> {
        const response = await this.updateOutboundOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Aktualisiert einen Artikel innerhalb eines Warenausgangsauftrags
     * Auftragsartikel aktualisieren
     */
    async updateOutboundOrderItemRaw(requestParameters: UpdateOutboundOrderItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutboundOrderItem>> {
        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
            throw new runtime.RequiredError('orderId','Required parameter requestParameters.orderId was null or undefined when calling updateOutboundOrderItem.');
        }

        if (requestParameters.itemId === null || requestParameters.itemId === undefined) {
            throw new runtime.RequiredError('itemId','Required parameter requestParameters.itemId was null or undefined when calling updateOutboundOrderItem.');
        }

        if (requestParameters.outboundOrderItem === null || requestParameters.outboundOrderItem === undefined) {
            throw new runtime.RequiredError('outboundOrderItem','Required parameter requestParameters.outboundOrderItem was null or undefined when calling updateOutboundOrderItem.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/outbound-orders/{orderId}/items/{itemId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters.orderId))).replace(`{${"itemId"}}`, encodeURIComponent(String(requestParameters.itemId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OutboundOrderItemToJSON(requestParameters.outboundOrderItem),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutboundOrderItemFromJSON(jsonValue));
    }

    /**
     * Aktualisiert einen Artikel innerhalb eines Warenausgangsauftrags
     * Auftragsartikel aktualisieren
     */
    async updateOutboundOrderItem(requestParameters: UpdateOutboundOrderItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutboundOrderItem> {
        const response = await this.updateOutboundOrderItemRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetOutboundOrdersOrderByEnum = {
    Asc: 'asc',
    Desc: 'desc',
    UnknownDefaultOpenApi: '11184809'
} as const;
export type GetOutboundOrdersOrderByEnum = typeof GetOutboundOrdersOrderByEnum[keyof typeof GetOutboundOrdersOrderByEnum];
